module.exports = __webpack_public_path__ + "img/game--battlefield-2042--esrb.05d42022.png";